export default __webpack_public_path__ + "static/media/Asc_Black.b02c0785.png";